import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { select, Store } from '@ngrx/store';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { GCI140Service } from '../../../../services/gci140.service';
import { first } from 'rxjs/internal/operators/first';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { NgForm } from '@angular/forms';
import { DashboardWidgetsService } from '../../../../services/dashboard-widgets.service';
import { environment } from 'src/environments/environment';
import { updatei140StepStatus, updateStepStatusSuccess, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { LookupService } from 'src/app/services/lookup-data.service';
import { USER_PERMISSIONS } from 'src/app/data/constants/permissions';
import { AuthenticationService } from 'src/app/services/authentication.service';
// import moment from 'moment';
import { AppServicesLibraryService } from 'app-services-library';
import { take } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-review-i140-petition',
  templateUrl: './review-i140-petition.component.html',
  styleUrls: ['./review-i140-petition.component.scss']
})
export class ReviewI140PetitionComponent implements OnInit {
  @ViewChild('printReviewForm', { static: true }) printReviewForm: NgForm;

  users: any;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  printPetitionBlock: boolean;
  enableViewDraftButton: boolean;
  draftGeneratedDate: string;
  disableSave: boolean;
  notiferReviewer: boolean;
  draftPDFPath: string;
  isReviewed: boolean = false;
  observableSubscription$ = new Subject();
  reviewStatusList: any;
  reviewerdata = {
    reviewerName: '',
    reviewerDesignation: '',
    id: null
  };

  review: {
    reviewCode: string,
    reviewNote: string,
    statusCode: string,
  }

  primaryData; // need to check if needed
  shouldLoadTab: boolean;
  showNext: boolean = false;
  showPrev: boolean = false;
  constructor(
    private petitionerService: PetitionerService,
    private authenticationService: AuthenticationService,
    private lookupService: LookupService,
    private gcI140Service: GCI140Service,
    private toastr: ToastrService,
    private store: Store<any>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private guard: DirtyFormGuard,
    private dashboardService: DashboardWidgetsService,
    private appServicesLibraryService: AppServicesLibraryService,
    private permissionsService: NgxPermissionsService
  ) {
    this.review = {
      reviewCode: "",
      reviewNote: "",
      statusCode: "",
    }
    this.disabledControls = false;
    this.printPetitionBlock = false;
    this.draftGeneratedDate = '';
    this.disableSave = false;
    this.notiferReviewer = false;
    this.draftPDFPath = '';
    this.showNext = this.dynamicDialogConfig.data?.showNext; 
    this.showPrev = this.dynamicDialogConfig.data?.showPrev;
  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data) {
        data['permissions'].forEach(el => {
          if (el === USER_PERMISSIONS.PETITION_REVIEWER) {
            this.disabledControls = false;
          }
        });
      }
    });
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    this.lookupService.getReviewersUser(this.dynamicDialogConfig.data.companyId, USER_PERMISSIONS.PETITION_REVIEWER).subscribe((data: Array<any>) => {
      this.users = data;
    });
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      if (data.stepReviewDetails) {
        this.review.reviewCode = data.stepReviewDetails.stepReviewCode;
        this.review.reviewNote = data.stepReviewDetails.stepReviewNote;
      }
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.toggleControlsStatus();
      this.getReviewStatusList();
      this.initReviewerDetails();
      this.getGenernatedPetition(true);
    });
  }

  ngAfterViewInit() {
    this.printReviewForm.valueChanges.subscribe(() => {
      if (this.printReviewForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
    this.showTabPermission();
  }

  async showTabPermission() {
    this.shouldLoadTab = this.dynamicDialogConfig?.data && await this.permissionsService.hasPermission('EDIT_PETITION');
  }

  userSelected({ value }) {
    this.reviewerdata.reviewerName = this.users.find(x => x.id === value)['firstName'] + ' ' + this.users.find(x => x.id === value)['lastName']
    this.reviewerdata.reviewerDesignation = this.users.find(x => x.id === value)['designation'];
  }

  initReviewerDetails() {
    this.gcI140Service.getPetionReviewerDetails(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId)
      .pipe(take(1))
      .subscribe((response
        : ImagilityBaseResponse) => {
        if (response && response.data['id']) {
          this.reviewerdata = {
            id: response.data['id'],
            reviewerDesignation: response.data['designation'],
            reviewerName: response.data['firstName']
          }
          this.isReviewed = true;
        } else {
          this.appServicesLibraryService
            .getTask('I140', this.dynamicDialogConfig.data.subTaskId)
            .subscribe((response: any) => {
              if (response) {
                this.reviewerdata.id = response.signatoryId;
                this.reviewerdata.reviewerDesignation = response.signatoryDetails?.designation;
              }
            });
          this.isReviewed = false;
        }
      });
  }

  saveReviewerDetails() {
    this.gcI140Service.savePetionReviewerDetails(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.reviewerdata.id).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.notiferReviewer = true;
        this.printReviewForm.resetForm(this.printReviewForm.value);
        this.isReviewed = true;
      }
      else {
        this.notiferReviewer = false;
      }
    });
  }

  generatePetition(isDraft: boolean = true) {
    this.gcI140Service.postReviewPetitiondocDraft(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, isDraft).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.data) {
        this.enableViewDraftButton = response.data.isExist;
        this.draftGeneratedDate = response.data.lastModifiedTime;
        this.draftPDFPath = response.data.path;
        this.toastr.success(response.message, 'Success');
      }
    });
  }

  getGenernatedPetition(isDraft: boolean = true) {
    this.gcI140Service.getReviewPetitiondocDraft(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, isDraft).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.enableViewDraftButton = response.data.isExist;
        this.draftGeneratedDate = response.data.lastModifiedTime;
        this.draftPDFPath = response.data.path;
      }
    });
  }

  viewPetitionDraft(draftPDFPath) {
    window.open(`${environment.docs}${draftPDFPath.substring(23)}`);
  }

  notifyReviewer() {
    this.gcI140Service.postNotifyReviewer(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
      }
    });
  }

  submitReview() {
    const payload = {
      benchMarkActionCode: "",
      endDate: "",
      isAttorneyNotify: 0,
      isBeneficiaryNotify: 0,
      isPetitionerNotify: 0,
      receiptCategory: "",
      receiptDate: "",
      receiptNumber: "",
      receiptType: "",
      responseCode: "",
      responseNote: "",
      reviewCode: this.review.reviewCode,
      reviewNote: this.review.reviewNote,
      startDate: "",
      statusCode: this.review.reviewCode === 'COMPLETE' ? 'COMPLETE' : 'INPROGRESS',
      stepNote: "",
    }
    this.gcI140Service.postActionCode(this.dynamicDialogConfig.data.subTaskId, this.stepDetails.stepActionList[0].layoutCode, payload).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        if (this.review.reviewCode === 'NOT_REVIEWED') {
          this.toastr.success('Petition review is not started', 'Success');
        }
        if (this.review.reviewCode === 'SEND_BACK') {
          this.toastr.success('Petition is sent back', 'Success');
        }
        if (this.review.reviewCode === 'COMPLETE') {
          this.toastr.success('Petition review is completed', 'Success');
        }
        this.printReviewForm.resetForm(this.printReviewForm.value);
        this.store.dispatch(updateStepStatusSuccess({ response: response }));
      }
    })
  }

  get DynamicDialogConfigData() {
    return this.dynamicDialogConfig;
  }

  getReviewStatusList() {
    this.dashboardService.getStatusAndResponse("GENSTEP").subscribe((response) => {
      this.reviewStatusList = response['review'] as [];
    });
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();

      }
      else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.store.dispatch(updateStepStatusToInitialState());
  }

}


